/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SubscriptionActionResponse
 */
export interface SubscriptionActionResponse {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionActionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionActionResponse
     */
    'type'?: SubscriptionActionResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionActionResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionActionResponse
     */
    'endDate'?: string;
}

export const SubscriptionActionResponseTypeEnum = {
    Pause: 'PAUSE'
} as const;

export type SubscriptionActionResponseTypeEnum = typeof SubscriptionActionResponseTypeEnum[keyof typeof SubscriptionActionResponseTypeEnum];


